var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 4.3645C6.11217 4.3645 3.5 6.97667 3.5 10.1978V19.5312C3.5 22.7523 6.11217 25.3645 9.33333 25.3645H18.6667C21.8878 25.3645 24.5 22.7523 24.5 19.5312V10.1978C24.5 6.97667 21.8878 4.3645 18.6667 4.3645H9.33333ZM21 6.69784C21.644 6.69784 22.1667 7.2205 22.1667 7.8645C22.1667 8.5085 21.644 9.03117 21 9.03117C20.356 9.03117 19.8333 8.5085 19.8333 7.8645C19.8333 7.2205 20.356 6.69784 21 6.69784ZM14 9.03117C17.2212 9.03117 19.8333 11.6433 19.8333 14.8645C19.8333 18.0857 17.2212 20.6978 14 20.6978C10.7788 20.6978 8.16667 18.0857 8.16667 14.8645C8.16667 11.6433 10.7788 9.03117 14 9.03117ZM14 11.3645C13.0717 11.3645 12.1815 11.7333 11.5251 12.3896C10.8687 13.046 10.5 13.9362 10.5 14.8645C10.5 15.7928 10.8687 16.683 11.5251 17.3394C12.1815 17.9958 13.0717 18.3645 14 18.3645C14.9283 18.3645 15.8185 17.9958 16.4749 17.3394C17.1313 16.683 17.5 15.7928 17.5 14.8645C17.5 13.9362 17.1313 13.046 16.4749 12.3896C15.8185 11.7333 14.9283 11.3645 14 11.3645Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramFooter);
export default __webpack_public_path__ + "static/media/Instagram_footer.fe2e39f847bb26a14e251866b97ad18e.svg";
export { ForwardRef as ReactComponent };